import { browserName, browserVersion, osVersion, osName, mobileVendor, mobileModel, isMobile } from 'react-device-detect';
import { getLogger } from '@cld/upload-widget';
import appConfig from 'appConfig';
import { getCloudInfo } from 'services';
import defaults from './common/defaults';
import { getUploadSource } from './common/utils';

const logger = getLogger();

let currentlyRetrievingCloudInfo = false;

const ARRAY_PROPS_WITH_VALS = ['sources'];
const RECURSE_PROPS = ['styles', 'palette', 'images'];

const reduceConfigProps = (obj) =>
  Object.keys(obj).reduce((res, key) => {
    const val = obj[key];

    if (typeof val !== 'undefined') {
      if (val !== null && ~RECURSE_PROPS.indexOf(key)) {
        res[key] = reduceConfigProps(val);
      } else if (Array.isArray(val) && ~ARRAY_PROPS_WITH_VALS.indexOf(key)) {
        res[key] = val;
      } else {
        res[key] = val ? 1 : 0;
      }
    }

    return res;
  }, {});

const getLogFormattedConfig = (config) =>
  Object.keys(config).reduce((res, key) => {
    const val = config[key];

    return Array.isArray(val)
      ? res.concat(val.map((arrVal) => `${key}[]=${arrVal}`))
      : typeof val === 'object'
      ? res.concat(getLogFormattedConfig(val))
      : res.concat(`${key}=${val}`);
  }, []);

const serializeConfigForRequest = (config, consoleInfo) => {
  const withDefaults = {
    sources: defaults.sources,
    ...config,
    cloudName: undefined, // no string
  };

  let result = '';

  try {
    const reducedConfig = reduceConfigProps(withDefaults);
    result = getLogFormattedConfig(reducedConfig).join('&');
  } catch (ex) {
    logger.error('[uploader.cloudInfo]: failed to serialize config for info request', ex);
  }

  // eslint-disable-next-line no-undef
  const version = `${appConfig.uwVersion}-${VERSION}`;
  const browser = `${browserName}-${browserVersion}`;
  const device = isMobile ? `${mobileVendor}-${mobileModel}` : 'desktop';
  const os = `${osName}-${osVersion}`;
  const source = getUploadSource(consoleInfo);

  return `${result}&version=${version}&browser=${browser}&device=${device}&os=${os}&source=${source}`;
};

const getCloudInfoWithAnalytics = (config, consoleInfo) => {
  let promise;

  if (!currentlyRetrievingCloudInfo) {
    // avoid attempting to retrieve info from the server more than once
    const { cloudName } = config;
    currentlyRetrievingCloudInfo = true;

    logger.log(`[uploader]: about to fetch cloud info for cloud: ${cloudName}`);

    const reqParams = serializeConfigForRequest(config, consoleInfo);

    promise = getCloudInfo(cloudName, reqParams, config) // passing serialized config for analytics purposes
      .then((info) => {
        currentlyRetrievingCloudInfo = false;
        logger.log(`[uploader]: retrieved cloud info for cloud: ${cloudName}: `, info);

        return { cloudName, info };
      })
      .catch(() => {
        currentlyRetrievingCloudInfo = false;
        return null;
      });
  }

  return promise || Promise.resolve(null);
};

export default getCloudInfoWithAnalytics;
